import { FileCategory } from '@shared/constants'
import dayjs from 'dayjs'

import { deleteRequest, getRequest, postRequest, putRequest } from './request'


import { DOMAIN  } from './constant'

export const createDirApi = (dirname: string, parentId: string) => {
  return postRequest(`${DOMAIN}/api/folder`, {
    name: dirname,
    parentId
  })
}

export const createFileApi = (data: {
  folderId: string
  title: string,
  category: FileCategory
  extraInfo?: any
}) => {
  return postRequest(`${DOMAIN}/api/file`, data)
}

export const updateFile = (data: {
  id: string
  title?: string,
  folderId?: string
  extraInfo?: any
}) => {
  return putRequest(`${DOMAIN}/api/file`, data)
}

export const queryFileById = (id: string) => {
  return getRequest(`${DOMAIN}/api/file`, {
    id
  })
}


export const queryMyFiles = (folderId?: string, isDeleted = false) => {
  return getRequest(`${DOMAIN}/api/my_files`, {
    folderId,
    isDeleted: String(isDeleted)
  })
}

export const queryRecentModifyFiles = () => {
  return getRequest(`${DOMAIN}/api/files`, {
    from: String(dayjs().subtract(365, 'day').valueOf()),
    to: String(dayjs().add(1, 'day').endOf('day').valueOf()),
    limit: 20
  })
}

export const softDelete = (id: string) => {
  return deleteRequest(`${DOMAIN}/api/files/soft/${id}`)
}

export const hardDelete = (id: string) => {
  return deleteRequest(`${DOMAIN}/api/files/${id}`)
}

export const recoverFile = (data: {
  id: string
}) => {
  return putRequest(`${DOMAIN}/api/files/recover`, data)
}

export const copyFile = (data: {
  id: string
}) => {
  return postRequest(`${DOMAIN}/api/files/copy`, data)
}


export const getShareUrl = (data: {
  fileId: string,
  validTo: number,
  permission: number,
  givenUsers?: string[],
  accessLevel: number
}) => {
  return postRequest(`${DOMAIN}/api/share/file`, data)
}

export const updateSharedConfig = (id: string, data: {}) => {
  return putRequest(`${DOMAIN}/api/share/file/${id}`, data)
}

export const getShareFile = (uri: string, psd?: string) => {
  if (psd) {
    return getRequest(`${DOMAIN}/share/file/${uri}?use_psd=${psd}`)
  }
  return getRequest(`${DOMAIN}/share/file/${uri}`)
}
